import React, { useEffect, useMemo, useState } from 'react';

import { DeviceType } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';
import { Spinner } from 'components/ui/spinner';

import { StorePreview } from '../../Preview/Preview';

import { usePreview } from './usePreview.hook';

export const TemplateStudioPreview: React.FC<{
  isLoadingForm: boolean;
}> = ({ isLoadingForm }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { previewProps } = usePreview();

  useEffect(() => {
    setIsLoading(!previewProps || !previewProps.boot || !previewProps.offers);
  }, [previewProps]);

  const isMobile = useMemo(
    () => previewProps.device === DeviceType.MOBILE,
    [previewProps]
  );

  return (
    <div
      className={cn(
        'flex flex-1 min-w-0 h-auto justify-center items-center bg-neutral-100 rounded-lg mb-6 px-6',
        !isMobile && 'pt-6',
        isLoadingForm && 'opacity-0'
      )}
    >
      {isLoading ? (
        <Spinner className="absolute top-1/2 left-1/2 size-14" />
      ) : (
        <StorePreview previewProps={previewProps} />
      )}
    </div>
  );
};
